export class AlterarTagsProdutoRequest {
    public idsProduto: number[] = [];
    public idsTag: number[] = [];
    public isIncluir: boolean = true;
}
